import Vue from 'vue';

export const basketFilters = {
  pricePerPerson: function (total, people) {
    return total / people;
  },
  taxAmount: function (total, tax) {
    return total * tax;
  },
  grossAmount: function (total, tax) {
    return basketFilters.taxAmount(total, tax) + total;
  },
  currency: function (value, symbol) {
    return symbol.concat(value.toFixed(2).toString());
  },
  discount: function (value, percent) {
    return value - (value * percent);
  },
  suffix: function (value, suffix) {
    return value.toFixed(2).toString().concat(suffix);
  },
  init: function () {
    Vue.filter('pricePerPerson', basketFilters.pricePerPerson);
    Vue.filter('taxAmount', basketFilters.taxAmount);
    Vue.filter('grossAmount', basketFilters.grossAmount);
    Vue.filter('currency', basketFilters.currency);
    Vue.filter('discount', basketFilters.discount);
    Vue.filter('suffix', basketFilters.suffix);
  }
}